<ion-header>
  <div class="modal-header">
    <div class="modal-title">
      <h3>{{ modalTitle }}</h3>
    </div>
    <ion-toolbar>
      <ion-buttons slot="end">
        <ion-button
          fill="clear"
          shape="round"
          class="close-button"
          (click)="dismiss()"
        >
          <ion-icon name="close"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </div>

  <div class="form-content">
    <ion-label class="input-label">Title *</ion-label>
    <ion-textarea
      #titleInput
      placeholder="Enter task title"
      [(ngModel)]="title"
      class="input-field"
      rows="1"
      [autoGrow]="true"
    >
    </ion-textarea>

    <ion-label class="input-label">Description</ion-label>
    <ion-textarea
      placeholder="Enter task description"
      [(ngModel)]="description"
      class="input-field"
      rows="3"
      [autoGrow]="true"
    >
    </ion-textarea>

    <!-- Provider-specific project selection -->
    <div *ngIf="requiresProjectSelection">
      <ion-label class="input-label">{{ projectSelectionLabel }} *</ion-label>
      <ion-select
        [(ngModel)]="selectedProject"
        (ngModelChange)="onProjectChange($event)"
        placeholder="Select {{ projectSelectionLabel.toLowerCase() }}"
        class="input-field"
        interface="popover"
      >
        <ion-select-option
          *ngFor="let option of projectOptions"
          [value]="
            isGithub
              ? option.name
              : isMonday || isAsana
                ? option.id
                : option.key
          "
        >
          {{ isGithub ? option.name : isMonday ? option.name : option.name }}
        </ion-select-option>
      </ion-select>
    </div>

    <ion-label class="input-label">Assignee</ion-label>
    <br />
    <ion-chip
      mode="ios"
      class="select-chip select-outline no-margin input-field full-width"
      [outline]="true"
      (click)="selectExternalTaskManagerUser()"
      style="justify-content: space-between"
    >
      <ion-label>{{ selectedAssignee?.name ?? "Select assignee" }}</ion-label>
      <ion-icon
        name="caret-down-outline"
        class="icon-padded-left button-icon"
      ></ion-icon>
    </ion-chip>

    <!-- JIRA specific fields -->
    <div *ngIf="isJira">
      <ion-label class="input-label">Issue Type (optional)</ion-label>
      <ion-input
        placeholder="Enter JIRA issue type"
        [(ngModel)]="jiraIssueTypeName"
        class="input-field"
      >
      </ion-input>
    </div>
  </div>

  <ion-button
    size="block"
    (click)="submit()"
    [disabled]="isLoading"
    class="submit-button"
  >
    Create Task
    <ion-spinner
      name="crescent"
      [hidden]="!isLoading"
      style="margin-left: 10px"
    ></ion-spinner>
  </ion-button>
</ion-header>
